import store from '@/store';
import { subscriptionActiveStatuses } from '@/common/config';

export const redirectAuthenticatedUsers = (to, from, next) => {
  const { loggedIn: userLoggedIn, details } = store.state.user;
  if (userLoggedIn) {
    const { emailVerified } = details;
    return next(emailVerified ? '/dashboard' : '/email-verification');
  }

  return next();
};

export const requireSubscription = (to, from, next) => {
  const { details: { subscriptionStatus } } = store.state.user;

  return subscriptionStatus ? next() : next('/checkout');
};

export const requirePayment = (to, from, next) => {
  const { details: { subscriptionStatus } } = store.state.user;

  return subscriptionActiveStatuses.includes(subscriptionStatus)
    ? next()
    : next('/dashboard');
};

export const requireEmailVerification = (to, from, next) => {
  const { details: { emailVerified } } = store.state.user;

  return emailVerified ? next() : next('/email-verification');
};

const runGuards = (guards, to, from, next) => {
  const queue = [...guards];
  const currentGuard = queue.shift();

  if (!currentGuard) return next();

  const nextHandler = nextArg => (nextArg ? next(nextArg) : runGuards(queue, to, from, next));
  return currentGuard(to, from, nextHandler);
};

export const multiguard = (guards = []) => (to, from, next) => runGuards(guards, to, from, next);
